import { get, post } from '@/common/request/index';

/**
 * 城市列表
 * https://yapi.lanhanba.com/project/208/interface/api/28477
 */
export function cityList() {
  return get('/v2/city/list', {}, true);
}

/**
 * 主力城市列表
 * https://yapi.lanhanba.com/project/469/interface/api/89166
 */
export function cityTopList() {
  return get('/v2/citySearch/topList', {}, true);
}

/**
 * 城市搜索统计， 结果会作用到 /v2/citySearch/topList接口
 * https://yapi.lanhanba.com/project/469/interface/api/89150
 */
export function citySearchStatistic(params) {
  return post('/v2/citySearch/statistic', params, true);
}


/**
 * 开通城市列表
 * https://yapi.lanhanba.com/project/208/interface/api/28501
 */
export function cityLocated() {
  return get('/v2/city/located', {}, true);
}

/**
 * 省市区列表
 *
 */
export function pcdList(params) {
  return get('/v2/area/list', params, { needCancel: false });
}

/**
 * 主力城市列表
 * https://yapi.lanhanba.com/project/469/interface/api/89166
 */
export function topCityList() {
  return get('/v2/citySearch/topList', {}, true);
}

/**
 * 城市搜索统计
 * https://yapi.lanhanba.com/project/469/interface/api/89166
 */
export function postCityStatistic(params: any) {
  return post('/v2/citySearch/statistic', params, true);
}
